import {
  canViewerPermission,
  getViewerEmailFromStorage,
  getViewerRoleType,
  isViewerAdministrator,
  isViewerCoordinator,
} from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";
import { isSalesManagerRoleType } from "./projectLandingTabAccess";

export const OPPORTUNITY_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "closed", label: "Close Won" },
  { value: "lost", label: "Lost" },
];

export const PERSON_ROLE_OPTIONS = [
  { value: "site", label: "Site" },
  { value: "it", label: "IT" },
  { value: "accounting", label: "Accounting" },
  { value: "other", label: "Other" },
];

export function crmPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.CRM);
}

function isSalesRoleType(roleType) {
  if (!roleType) return false;
  if (isSalesManagerRoleType(roleType)) return true;
  const name = String(roleType.name || "")
    .trim()
    .toLowerCase();
  return name.includes("sales");
}

export function canViewCrm(viewerEmail) {
  if (!crmPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (isViewerAdministrator(email) || isViewerCoordinator(email)) return true;
  if (canViewerPermission(email, "canAccessCrm", false)) return true;
  return isSalesRoleType(getViewerRoleType(email));
}

export function canManageCrm(viewerEmail) {
  return canViewCrm(viewerEmail);
}

export function opportunityStatusLabel(status) {
  const hit = OPPORTUNITY_STATUS_OPTIONS.find((o) => o.value === status);
  return hit?.label ?? String(status || "—");
}

export function opportunityStatusClass(status) {
  if (status === "closed") return "crm-status--closed";
  if (status === "lost") return "crm-status--lost";
  return "crm-status--open";
}

export function personRoleLabel(role) {
  const hit = PERSON_ROLE_OPTIONS.find((o) => o.value === role);
  return hit?.label ?? "Other";
}
